import React, { Component } from "react";
import { Paper, Box, Typography, Button } from "@mui/material";
import { ErrorOutline, Home } from "@mui/icons-material";

class ErrorPage extends Component {
    render() {
        return (
            <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center",
                padding: window.innerWidth < 600 ? "16px" : "20px",
                minHeight: "80vh"
            }}>
                <Paper
                    elevation={3}
                    sx={{
                        maxWidth: "600px",
                        width: { xs: '100%', sm: 'auto' },
                        borderRadius: { xs: '12px', sm: '20px' },
                        overflow: 'hidden',
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                        textAlign: 'center'
                    }}
                >
                    {/* Header with gradient */}
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #d32f2f 0%, #f44336 100%)',
                            p: { xs: 3, sm: 4 },
                            color: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: { xs: 1.5, sm: 2 }
                        }}
                    >
                        <ErrorOutline 
                            sx={{ 
                                fontSize: { xs: '80px', sm: '120px' },
                                animation: 'pulse 2s ease-in-out infinite',
                                '@keyframes pulse': {
                                    '0%, 100%': { 
                                        transform: 'scale(1)',
                                        opacity: 1
                                    },
                                    '50%': { 
                                        transform: 'scale(1.05)',
                                        opacity: 0.8
                                    }
                                }
                            }} 
                        />
                        <Typography variant="h2" sx={{ fontWeight: 700, fontSize: { xs: '2.5rem', sm: '4rem' } }}>
                            404
                        </Typography>
                    </Box>

                    <Box sx={{ p: { xs: 3, sm: 5 } }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, color: "#1a1a1a", mb: 2, fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
                            Seite nicht gefunden
                        </Typography>
                        <Typography variant="body1" sx={{ color: "#666", mb: { xs: 3, sm: 4 }, fontSize: { xs: '0.95rem', sm: '1.1rem' } }}>
                            Die Seite, die Sie suchen, existiert nicht oder wurde verschoben.
                        </Typography>

                        <Button
                            variant="contained"
                            size="large"
                            fullWidth={window.innerWidth < 600}
                            startIcon={<Home />}
                            href="/"
                            sx={{
                                bgcolor: '#2e7d32',
                                color: 'white',
                                fontWeight: 600,
                                textTransform: 'none',
                                fontSize: { xs: '0.95rem', sm: '1.1rem' },
                                py: { xs: 1.3, sm: 1.5 },
                                px: { xs: 2, sm: 4 },
                                borderRadius: '10px',
                                boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                                '&:hover': {
                                    bgcolor: '#1b5e20',
                                    boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                                    transform: 'translateY(-2px)'
                                },
                                transition: 'all 0.2s ease'
                            }}
                        >
                            Zurück zur Startseite
                        </Button>
                    </Box>
                </Paper>
            </div>
        )
    }
}

export default ErrorPage;